// Fixed-timestep scheduling. Real elapsed time is converted to simulated time
// (timeScale lets an artist speed drying up) and consumed in fixed steps, so
// the physics produces the same result at 30, 60 or 144 frames per second.
// A per-frame budget caps the work; leftover time carries to the next frame
// rather than being dropped, and a backlog cap stops a stalled tab from
// trying to catch up minutes of simulation at once.

export const SIM_STEP = 1 / 30;

export function createScheduler(options = {}) {
  return {
    timeScale: options.timeScale ?? 1,
    accumulator: 0,
    maxBacklog: options.maxBacklog ?? 1.0,
    maxStepsPerFrame: options.maxStepsPerFrame ?? 4,
  };
}

// Returns the number of fixed steps to run for this frame.
export function stepsForFrame(scheduler, realSeconds) {
  const dt = Math.max(0, Math.min(0.25, Number(realSeconds) || 0)) * scheduler.timeScale;
  scheduler.accumulator = Math.min(scheduler.maxBacklog, scheduler.accumulator + dt);
  let steps = Math.floor(scheduler.accumulator / SIM_STEP);
  steps = Math.min(steps, scheduler.maxStepsPerFrame);
  scheduler.accumulator -= steps * SIM_STEP;
  return steps;
}
